import FAEventCardPicture from './FAEventCardPicture'
export default FAEventCardPicture
